import { SvgIcon } from '@mui/material';
import { SMPalette } from '@nx-smartmonkey/ui';

interface WeightProps {
  color?: string;
  style?: React.CSSProperties;
}

export default function Weight({ color = SMPalette.grey1, style = {} }: WeightProps) {
  return (
    <SvgIcon viewBox="0 0 22.34 23.25" style={{ width: `24px`, ...style }}>
      <g>
        <path
          fill={color}
          d="m22.17,21.2l-2.81-15.12c-.14-.73-.78-1.26-1.53-1.26h-4.18c.9-1.37.53-3.21-.84-4.11-1.37-.9-3.21-.53-4.11.84-.66.99-.66,2.28,0,3.27h-4.18c-.75,0-1.4.53-1.53,1.27L.16,21.2c-.16.85.4,1.66,1.25,1.82.09.02.19.03.28.03h18.96c.86,0,1.56-.7,1.56-1.56,0-.1,0-.2-.03-.29h-.01ZM11.17,1.66c.84,0,1.52.68,1.52,1.52,0,.84-.68,1.52-1.52,1.52-.84,0-1.52-.68-1.52-1.52,0-.84.68-1.52,1.52-1.52h0Zm9.47,19.94H1.69l-.12-.13,2.83-15.12c0-.06.06-.1.12-.1h13.31c.05,0,.1.04.11.09l2.81,15.12-.11.13h0Z"
        />
      </g>
    </SvgIcon>
  );
}
